function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 7a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM9.5 9.5c0-.481.227-.91.58-1.184A1.99 1.99 0 009 8H2.5a2 2 0 00-2 2s0 4 5.25 4c1.953 0 3.18-.554 3.95-1.25a1.51 1.51 0 01.182-.25 1.494 1.494 0 01-.382-1c0-.384.144-.735.382-1a1.494 1.494 0 01-.382-1zm6.5-5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM11 9a.5.5 0 000 1h6a.5.5 0 000-1h-6zm0 2a.5.5 0 000 1h6a.5.5 0 000-1h-6zm0 2a.5.5 0 000 1h6a.5.5 0 000-1h-6z",
  fill: "#8F90A6"
});

function SvgAffectedUserRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAffectedUserRequest;